import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import { BrowserRouter } from 'react-router-dom';

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('property-explorer-root');
  if (container) {
    const root = createRoot(container);
    const basePath = `/property-explorer`;

    root.render(
      <BrowserRouter>
        <App basePath={basePath} />
      </BrowserRouter>
    );
  }
});